import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "./LogoSlider.scss"
import emirates from "../../assets/images/emirates-logo.webp"
import eygpt from "../../assets/images/eygpt.webp"
import eithad from "../../assets/images/etihad.webp"
import american from "../../assets/images/american.webp"
import lufthansa from "../../assets/images/lufthansa.webp"
import saudi from "../../assets/images/saudi.webp"
import turkish from "../../assets/images/turkish.webp"
import rj from "../../assets/images/rj.webp"
import qatar from "../../assets/images/qatar.webp"

const LogoSlider = () => {

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 2560, min: 1440 },
            items: 7
        },
        desktop: {
            breakpoint: { max: 1440, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2
        }
    };
    return(
        <Carousel autoPlay={true}   autoPlaySpeed={1000} showDots={false} infinite={true} removeArrowOnDeviceType={["superLargeDesktop","desktop","tablet", "mobile"]} responsive={responsive}>
            <div className="logosliderimgdiv">
            <img  className="imgdiv" src={emirates} width="auto" height="auto" />
            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={eygpt} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={eithad} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={american} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={lufthansa} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={saudi} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={turkish} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={rj} width="auto" height="auto" />

            </div>
            <div className="logosliderimgdiv">

            <img className="imgdiv" src={qatar} width="auto" height="auto" />

            </div>
        </Carousel>
    )
}

export default LogoSlider